import React from 'react';
import { styled } from '../../style';
import { pickColor } from '../../style/theme/utils';

interface Props {
  className?: string;
}

export function Asterisk({ className }: Props) {
  return <AsteriskContainer className={className}>*</AsteriskContainer>;
}

const AsteriskContainer = styled.div`
  color: ${pickColor((c) => c.primary1)};
  font-size: 24px;
  padding-left: 2px;
  display: inline-block;
`;
